<script>
import { apiSecond } from '@/boot/axios'
import MainFilters from '@/components/MainFilters.vue'

export default {
	name: 'ReportAnalyticsIndex',
	components: {
		MainFilters,
	},
	data() {
		return {
			applications: null,
			errorMessage: {
				status: null,
				text: null,
			},
			message: {
				status: null,
				text: null,
			},
			filters: {
				pools: null,
				status: null,
			},
			options: {
				itemsPerPage: 15,
				page: 1,
			},
			headers: [
				{ text: 'ID', value: 'id' },
				{ text: this.$t('headers.user'), value: 'user.first_name' },
				{ text: this.$t('headers.region'), value: 'region.title' },
				{ text: this.$t('headers.district'), value: 'district.title' },
				{ text: this.$t('headers.farm'), value: 'farm.title' },
				{ text: this.$t('headers.status'), value: 'status.name_ru' },
				{ text: this.$t('headers.surrender_date_start'), value: 'surrender_date_start' },
				{ text: this.$t('headers.surrender_date_end'), value: 'surrender_date_end' },
				{ text: this.$t('headers.payment_plan'), value: 'payment_plan' },
				{ text: this.$t('headers.payment_fact'), value: 'payment_fact' },
				{ text: this.$t('headers.total_fish'), value: 'total_fish' },
				{ text: this.$t('headers.created_at'), value: 'created_at' },
			],
			total: 0,
		}
	},
	methods: {
		pagination(options) {
			this.fetchReportData(options.page, options.itemsPerPage)
		},

		async fetchReportData(page = 1, per_page = 15) {
			try {
				this.errorMessage = { status: null, text: null }

				// Get filters from route query
				const query = this.$route.query

				let url = 'v1/admin/report1-list'
				const urlParams = new URLSearchParams()

				// Add pagination parameters
				urlParams.append('page', page)
				urlParams.append('per_page', per_page)

				// Add filter parameters
				if (query.pools) {
					urlParams.append('pool_id', query.pools)
				}

				if (query.status) {
					urlParams.append('status_id', query.status)
				}

				// Build the final URL with query parameters
				if (urlParams.toString()) {
					url += '?' + urlParams.toString()
				}

				const response = await apiSecond.get(url)

				if (response.data) {
					this.applications = response.data.data
					this.total = response.data.total
				}
			} catch (error) {
				console.error('Error fetching report data:', error)
				this.errorMessage = {
					status: error.response?.status || 500,
					text: error.response?.data?.message || 'Ошибка загрузки данных',
				}
			}
		},

		async search() {
			this.options.page = 1
			this.pagination(this.options)
		},
	},

	async mounted() {
		await this.fetchReportData(1, this.options.itemsPerPage)
	},
}
</script>

<template>
	<div class="wrap__content" v-bind:class="{ 'wrap__content--preloader': !applications }">
		<v-preloader v-if="!applications" :message="errorMessage"></v-preloader>

		<div class="container" v-if="applications">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['ReportAnalyticsManagement']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content">
							<div class="card__content-header">
								<div class="content__title">
									<div class="content__title--element">
										<div class="content__title--text">
											{{ $t('sidebar.report_analytics') }}
										</div>
									</div>
								</div>
							</div>
							<div class="card__content--body">
								<div class="table__block--content">
									<div class="table__block--filter">
										<MainFilters
											:filter-keys="['pools', 'status']"
											class="mb-4"
											:use-report-status="true"
											:filter-options="{
												pools: {
													multiple: false,
												},
												status: {
													multiple: false,
												},
											}"
											@search="search"
										/>
									</div>

									<v-data-table
										:headers="headers"
										:items="applications"
										:loading="false"
										:options.sync="options"
										:footer-props="{
											'items-per-page-options': [5, 10, 15, 20, 30, 50],
										}"
										:server-items-length="total"
										@update:options="pagination($event)"
									>
										<template slot="item.user.first_name" slot-scope="{ item }">
											{{ item.user?.first_name }} {{ item.user?.last_name }}
										</template>

										<template slot="item.region.title" slot-scope="{ item }">
											{{ item.region?.title }}
										</template>

										<template slot="item.district.title" slot-scope="{ item }">
											{{ item.district?.title }}
										</template>

										<template slot="item.farm.title" slot-scope="{ item }">
											{{ item.farm?.title }}
										</template>

										<template slot="item.status.name_ru" slot-scope="{ item }">
											<a
												class="tb__table--status"
												:class="{
													'tb__status--success': item.status?.value === 'active',
													'tb__status--error': item.status?.value === 'deleted',
												}"
											>
												{{ item.status?.name_ru }}
											</a>
										</template>

										<template slot="item.surrender_date_start" slot-scope="{ item }">
											{{ item.surrender_date_start | formatOnlyDate }}
										</template>

										<template slot="item.surrender_date_end" slot-scope="{ item }">
											{{ item.surrender_date_end | formatOnlyDate }}
										</template>

										<template slot="item.created_at" slot-scope="{ item }">
											{{ item.created_at | formatDate }}
										</template>

										<v-alert slot="no-results" :value="true" color="error">
											{{ $t('system_message.search') }}
										</v-alert>
									</v-data-table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped></style>
